// Department names must be unique per hospital. These helpers mirror the server-side check in
// apps/server/src/services/HospitalService.js (assertDepartmentNameIsAvailable) so the UI can warn
// before the request is sent.

export const DUPLICATE_HEBREW_NAME_MESSAGE = 'קיימת כבר מחלקה בשם זה בבית חולים זה';
export const DUPLICATE_ENGLISH_NAME_MESSAGE = 'קיימת כבר מחלקה עם שם זה באנגלית בבית חולים זה';

// Names are compared trimmed and case-insensitively.
export const normalizeDepartmentName = (name) =>
  typeof name === 'string' ? name.trim().toLowerCase() : '';

/**
 * Returns { nameHebrew?, nameEnglish? } error messages for names already taken by another
 * department of the same hospital.
 *
 * `currentDepartment` is the department being edited (omit when creating). A name that is unchanged
 * relative to it is always allowed, so departments that were duplicated before this rule existed
 * stay editable.
 */
export const getDepartmentNameErrors = (departments, values, currentDepartment = null) => {
  const errors = {};
  const nameHebrew = normalizeDepartmentName(values?.nameHebrew);
  const nameEnglish = normalizeDepartmentName(values?.nameEnglish);

  const siblings = (departments || []).filter(
    (dep) => !currentDepartment?._id || dep._id !== currentDepartment._id
  );

  if (
    nameHebrew &&
    nameHebrew !== normalizeDepartmentName(currentDepartment?.nameHebrew) &&
    siblings.some((dep) => normalizeDepartmentName(dep.nameHebrew) === nameHebrew)
  ) {
    errors.nameHebrew = DUPLICATE_HEBREW_NAME_MESSAGE;
  }

  if (
    nameEnglish &&
    nameEnglish !== normalizeDepartmentName(currentDepartment?.nameEnglish) &&
    siblings.some((dep) => normalizeDepartmentName(dep.nameEnglish) === nameEnglish)
  ) {
    errors.nameEnglish = DUPLICATE_ENGLISH_NAME_MESSAGE;
  }

  return errors;
};

/** Hebrew message returned by the server (axiosConfig flattens it onto `serverError`). */
export const getServerHebMessage = (error) =>
  error?.serverError?.hebMessage || error?.response?.data?.error?.hebMessage || '';
